import React from "react";
import { navigateTo } from "../../../utils/navigateTo";
import "./EngageCard.css";

interface EngageCardProps {
  image: string;
  title: string;
  link: string;
}

const EngageCard: React.FC<EngageCardProps> = ({ image, title, link }) => {
  const handleRedirect = () => {
    if (link.startsWith("http")) {
      window.open(link, "_blank");
    } else {
      navigateTo(link);
    }
  };

  return (
    <div className="engage-card-wrapper">
      <div className="engage-card horizontal-scroll-card">
        <img
          src={image}
          alt={title}
          className="engage-card-img"
          onClick={handleRedirect}
          style={{ cursor: "pointer" }}
        />
      </div>
      <div className="engage-card-footer">
        <span className="engage-card-title">{title}</span>
        <button className="engage-card-viewmore" onClick={handleRedirect}>
          View More <span className="engage-card-arrow">&#8594;</span>
        </button>
      </div>
    </div>
  );
};

export default EngageCard;
